import React, { Suspense, useEffect, useState } from 'react';
import i18n from 'i18next';
import { I18nextProvider, initReactI18next } from 'react-i18next';
import { useShallowAppSelector } from 'store/hooks';
import HttpApi from 'i18next-http-backend';
import { BASE_API_URL } from 'lib/setting';

function TranslationProvider({ children }: { children: React.ReactNode }) {
  const {
    language,
  }: {
    language: string;
  } = useShallowAppSelector(state => ({
    language: state.base.language || 'ko',
  }));

  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const initI18n = async () => {
      // 온라인 모드: CDN에서 번역 파일을 불러오는 경우
      try {
        await i18n
          .use(HttpApi)
          .use(initReactI18next)
          .init({
            lng: language.toLowerCase(),
            fallbackLng: language.toLowerCase(),
            backend: {
              loadPath: (lngs: string[], _namespaces: string[]) => {
                const lng = lngs[0];
                return `${process.env.REACT_APP_S3_PUBLIC_URL}/dof/lang/sync/translation.${lng}.json`;
              },
              crossDomain: true,
              requestOptions: {
                cache: 'no-cache',
              },
            },
            keySeparator: false,
            interpolation: {
              escapeValue: false,
            },
            react: {
              useSuspense: true,
            },
          });

        console.log('[I18N] HTTP Backend를 통한 i18n 초기화 완료');
        setIsInitialized(true);
      } catch (error) {
        console.error('[I18N] HTTP Backend i18n 초기화 중 오류 발생: ', error);
      }
    };

    initI18n();
  }, []);

  useEffect(() => {
    if (isInitialized && language) {
      i18n.changeLanguage(language.toLowerCase());
    }
  }, [language, isInitialized]);

  return (
    <Suspense fallback={<></>}>
      <I18nextProvider i18n={i18n}>{children}</I18nextProvider>
    </Suspense>
  );
}
export default TranslationProvider;
